var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"breadcrumb"},[_vm._v(_vm._s(_vm.$t("contact.info.breadcrumb")))]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"title"}),_vm._v(" "),_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.$t("contact.info.text"))}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fcef3d3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/contact/components/Contact.vue
// module id = null
// module chunks = 